<template>
  <div>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
    </div>

    <div class="pa-3">
      <v-skeleton-loader v-if="overlay" type="button" />
      <v-btn-toggle
        v-else
        v-model="archive"
        rounded
        mandatory>
        <v-btn
          small
          class="white--text"
          :outlined="archive !== true"
          color="primary">
          Todos
        </v-btn>
        <v-btn
          class="white--text"
          small
          :outlined="archive !== false"
          color="primary">
          Archivados
        </v-btn>
      </v-btn-toggle>
    </div>

    <v-flex xs12>
      <v-data-table
        v-if="table.paymentMethod.data.length"
        :loading-text="table.paymentMethod.title"
        :server-items-length="table.paymentMethod.total"
        :loading="table.paymentMethod.loading"
        :headers="table.paymentMethod.headers"
        :items="table.paymentMethod.data"
        :options="table.paymentMethod.options"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50]
        }"
        sort-by="name"
        @update:options="updateCategoriesTable"
        class="elevation-1">
        <template v-slot:[`item.incomeType`]="{ item }">
          <div>{{ item.incomeType ? item.incomeType.name : '' }}</div>
        </template>
        <template v-slot:[`header.name`]="{ header }">
          <span>{{ header.text }}</span>
          <v-btn
            v-if="paymentMethodsPermissions['create-payment-method']"
            fab
            depressed
            @click="openAddConceptDialog()"
            class="addButton"
          >
            <v-icon x-small>mdi-plus</v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <div>{{ item.name }}</div>
        </template>
        <template v-slot:[`item.wansoftName`]="{ item }">
          <div>{{ item.wansoftName }}</div>
        </template>
        <template v-slot:[`item.needInvoice`]="{ item }">
          <div>{{ item.needInvoice ? $t('expenses.incomeCategories.yes') : $t('expenses.incomeCategories.no') }}</div>
        </template>
        <template v-slot:[`item.editableTip`]="{ item }">
          <div>{{ item.editableTip ? $t('expenses.incomeCategories.yes') : $t('expenses.incomeCategories.no') }}</div>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <div>
            <v-btn
              v-if="!item.isGlobal && paymentMethodsPermissions['update-payment-method'] && archive !== 1"
              fab
              color="primary"
              x-small
              depressed
              @click="openAddConceptDialog({
                _id: item._id,
                incomeType: item.incomeType ? item.incomeType._id : '',
                name: item.name,
                wansoftName: item.wansoftName,
                needInvoice: item.needInvoice,
                editableTip: item.editableTip
              })"
              class="mr-2"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              v-if="!item.isGlobal && paymentMethodsPermissions['update-payment-method'] && archive !== 1"
              fab
              color="#78909C"
              class="white--text mr-2"
              x-small
              depressed
              @click="openArchivePaymentMethod(item)"
            >
              <v-icon>mdi-archive</v-icon>
            </v-btn>
            <!-- <v-btn
              v-if="!item.isGlobal && paymentMethodsPermissions['update-payment-method']"
              fab
              color="error"
              x-small
              depressed
              @click="openRemovePaymentMethod(item)"
              class="mr-2"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn> -->
          </div>
        </template>
      </v-data-table>
      <div
        v-else
        class="pa-3 grey lighten-4"
        >
        <div class="d-flex justify-center mt-6">
          <v-row
            align="center"
            justify="center">
            <v-icon
              size="150"
              color="primary">
              mdi-cogs
            </v-icon>
            <v-col cols="4">
              <div class="grey--text">
                <div
                  class="title mb-3 font-weight-bold">
                  Aún no tienes cofigurada ningun método de pago.
                </div>
                <div class="subtitle-2">
                  <div class="mb-3">
                    Crea alguno para poder tener un control de tus métodos de pagos.
                  </div>
                  <div>
                    <a class="primary--text" href="#" @click.prevent="openAddConceptDialog()" v-if="paymentMethodsPermissions['create-income-category']">Crear una categoría de ingreso</a>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-flex>

    <v-dialog @keydown.esc="removeDialog=false" v-model="removeDialog" persistent max-width="max-content">
      <v-card>
        <v-card-title>
          <span class="headline">¿Deseas eliminar {{ this.paymentMethod.name }} - {{ this.paymentMethod.wansoftName }}?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" small @click="onCloseRemoveDialog">No</v-btn>
          <v-btn color="primary" small @click="remove">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="archiveDialog=false" v-model="archiveDialog" persistent max-width="max-content">
      <v-card>
        <v-card-title>
          <span class="headline">¿Deseas archivar {{ this.paymentMethod.name }} - {{ this.paymentMethod.wansoftName }}?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" small @click="onCloseArchiveDialog">No</v-btn>
          <v-btn color="primary" small @click="archivePaymetMethod">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AddPaymentMethod
      ref="addConcept"
      @updated="loadCategories"
    />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import AddPaymentMethod from '@/components/modals/AddPaymentMethod'

export default {
  name: 'IncomeCategories',
  components: {
    AddPaymentMethod
  },
  data () {
    return {
      overlay: false,
      section: 'Métodos de pago',
      removeDialog: false,
      archiveDialog: false,
      paymentMethod: {},
      archive: false,
      table: {
        paymentMethod: {
          title: this.$i18n.t('expenses.incomeCategories.loading'),
          loading: true,
          headers: [
            { text: 'Concepto de ingreso', value: 'incomeType' },
            { text: 'Nombre de wansoft', value: 'wansoftName' },
            { text: 'Nombre de método de pago', value: 'name' },
            { text: 'Lleva factura', value: 'needInvoice' },
            { text: 'Propina editable', value: 'editableTip' },
            { text: '', value: 'action' }
          ],
          data: [],
          total: 0,
          options: {
            groupBy: [],
            groupDesc: [],
            itemsPerPage: 50,
            multiSort: false,
            mustSort: false,
            page: 1,
            sortBy: [''],
            sortDesc: []
          }
        }
      }
    }
  },
  watch: {
    restaurant: {
      handler: async function () {
        await this.loadCategories()
      },
      deep: true
    },
    archive: async function () {
      await this.loadCategories()
    }
  },
  computed: {
    paymentMethodsPermissions () {
      return this.$store.state.login.permissions['expenses'].components['payment-methods'].actions
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data
    }
  },
  methods: {
    async remove () {
      this.overlay = true
      try {
        await this.$api.del(`/v1/cashflows/${this.paymentMethod._id}`)
        await this.loadCategories()
        this.$toasted.show('Se ha eliminado el método de pago', { duration: 3000 })
        this.onCloseRemoveDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async archivePaymetMethod () {
      this.overlay = true
      try {
        await this.$api.put(`/v1/cashflows/${this.paymentMethod._id}`, { archived: true })
        await this.loadCategories()
        this.$toasted.show('Se ha archivado el método de pago', { duration: 3000 })
        this.onCloseArchiveDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    openRemovePaymentMethod (item) {
      this.paymentMethod = item
      this.removeDialog = true
    },
    onCloseRemoveDialog () {
      this.paymentMethod = {}
      this.removeDialog = false
    },
    openArchivePaymentMethod (item) {
      this.paymentMethod = item
      this.archiveDialog = true
    },
    onCloseArchiveDialog () {
      this.paymentMethod = {}
      this.archiveDialog = false
    },
    updateCategoriesTable: async function (data) {
      this.table.paymentMethod.options = data
      if (this.$store.state.area) {
        await this.loadCategories({
          type: 'paymentMethod',
          restaurant: this.$store.state.currentRestaurant.data._id,
          sort: data.sortDesc[0] ? data.sortBy[0] : `-${data.sortBy[0] || 'name'}`,
          limit: data.itemsPerPage,
          skip: (data.itemsPerPage * (data.page - 1)),
          archived: this.archive
        })
      }
    },
    async loadCategories (params = null) {
      params = params || {
        type: 'paymentMethod',
        restaurant: this.$store.state.currentRestaurant.data._id,
        archived: this.archive
      }
      this.table.paymentMethod.loading = true
      try {
        const response = await this.$api.get(`/v1/cashflows`, params)
        this.table.paymentMethod.data = response.data
        this.table.paymentMethod.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.paymentMethod.loading = false
    },
    openAddConceptDialog (concept) {
      this.$refs.addConcept.openDialog(concept)
    }
  }
}
</script>

<style lang="scss" scoped>
  .addButton {
    height: 20px;
    width: 20px;
    min-width: 20px;
    margin-left: 4px;
    background-color: #0F6FFF !important;
    color: #fff;
  }
</style>
